import { FC, Fragment } from 'react'

type SrcProp = {
  src: string
  type: string
}
interface PictureProps {
  src: string | SrcProp[]
  alt?: string
  className?: string
}

const Picture: FC<PictureProps> = ({ className = '', src = '', alt = '' }) => {
  if (typeof (src as string) === 'string') {
    const url = `${src}?v=${process.env.VERSION}`

    return (
      <picture className={className}>
        <source srcSet={`${url}, ${url.replace('.', 'x2.')} 2x`} />
        <img className={className} src={url} alt={alt} />
      </picture>
    )
  }

  return (
    <picture className={className}>
      {(src as SrcProp[]).map(({ src, type }) => {
        const url = `${src}?v=${process.env.VERSION}`

        return (
          <Fragment key={type}>
            <source
              srcSet={`${url}, ${url?.replace('.', 'x2.')} 2x`}
              type={type}
            />
            {type === 'image/jpeg' && (
              <img className={className} src={url as string} alt={alt} />
            )}
          </Fragment>
        )
      })}
    </picture>
  )
}

export default Picture
